import React, { useEffect, useState } from 'react';
import { undoPreview, undoDish } from './notInMenuApi';

const money = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

/** Preview then confirm an undo (the BanquetRevertModal pattern). */
export default function UndoDishConfirm({ groupKey, group = 'sales', itemName, onClose, onUndone }) {
  const [state, setState] = useState({ phase: 'loading' });

  useEffect(() => {
    let live = true;
    (async () => {
      const r = await undoPreview(groupKey, group);
      if (!live) return;
      if (!r.ok) setState({ phase: 'error', error: r.error });
      else if (!r.allowed) setState({ phase: 'refused', reason: r.reason });
      else setState({ phase: 'ready', preview: r });
    })();
    return () => { live = false; };
  }, [groupKey, group]);

  const run = async () => {
    setState((s) => ({ ...s, busy: true, error: null }));
    const r = await undoDish(groupKey, group);
    if (!r.ok) { setState((s) => ({ ...s, busy: false, error: r.error })); return; }
    onUndone(r);
  };

  const p = state.preview;
  return (
    <div className="nim-overlay nim-overlay-top" onClick={state.busy ? undefined : onClose}>
      <div className="nim-container nim-small" role="dialog" aria-label={`Undo ${itemName}`} onClick={(e) => e.stopPropagation()}>
        <div className="nim-header">
          <h3 className="nim-title">Undo {itemName}</h3>
          <button type="button" className="nim-close" aria-label="Close" onClick={onClose} disabled={state.busy}>×</button>
        </div>
        <div className="nim-body">
          {state.phase === 'loading' && <p className="um-muted">Checking…</p>}
          {state.phase === 'error' && <div className="um-error" role="alert">{state.error}</div>}
          {state.phase === 'refused' && <div className="um-warn">{state.reason}</div>}
          {state.phase === 'ready' && (
            <>
              <p>{p.lines} line{p.lines === 1 ? '' : 's'} go back to Not in Menu.</p>
              <ul className="nim-undo-list">
                {(p.stock || []).map((s) => <li key={s.item_id}>{s.name}: {s.quantity} {s.unit} back into stock</li>)}
              </ul>
              {p.revenue_amount > 0 && <p>{money(p.revenue_amount)} moves back to Not in Menu.</p>}
              {state.error && <div className="um-error" role="alert">{state.error}</div>}
            </>
          )}
        </div>
        <div className="nim-footer">
          <button type="button" className="um-undo-btn" onClick={onClose} disabled={state.busy}>Cancel</button>
          {state.phase === 'ready' && (
            <button type="button" className="um-primary-btn nim-danger" onClick={run} disabled={state.busy}>
              {state.busy ? 'Undoing…' : `Yes, undo ${itemName}`}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
